import { render, staticRenderFns } from "./StrainEditor.vue?vue&type=template&id=ddf055b2&"
import script from "./StrainEditor.vue?vue&type=script&lang=js&"
export * from "./StrainEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports